interface ListHeroProps {
  activeName: string;
  total: number;
}

export default function ListHero({ activeName, total }: ListHeroProps) {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20of%20a%20radar%20sweep%20over%20a%20city%20skyline%20at%20dusk%2C%20amber%20and%20terracotta%20glow%2C%20minimal%20editorial%20poster%20style%2C%20muted%20cream%20and%20orange%20palette%2C%20subtle%20grain%2C%20wide%20banner%20composition&width=1600&height=560&seq=511-frontline-banner&orientation=landscape"
          alt="围观前线暖色调抽象雷达插画"
          title="511群众围观前线瓜点列表"
          className="w-full h-full object-cover object-top opacity-60"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-black/25"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <p className="text-xs md:text-sm tracking-[0.18em] uppercase text-accent-400">Frontline</p>
        <h1 className="mt-3 font-heading font-black text-3xl md:text-5xl text-white leading-tight">
          围观前线
        </h1>
        <p className="mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-background-200">
          这里汇总吃瓜小队的全部记录。按主题筛选、按关键词搜索，快速找到你关心的那条瓜点。
        </p>
        <div className="mt-5 inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/25 text-background-50 text-xs md:text-sm">
          <i className="ri-filter-3-line"></i>
          当前：{activeName} · {total} 条
        </div>
      </div>
    </section>
  );
}